export default {
    SET_PAGE_TYPE: 'PAGE/SET_PAGE_TYPE',
    SET_PAGE_META: 'PAGE/SET_PAGE_META'
};
